export const faqData = [
  {
    id: 1,
    question: "What is a Home Loan EMI Calculator?",
    answer:
      "An EMI calculator helps you estimate your monthly loan repayment based on the loan amount, tenure, and interest rate. It provides an accurate figure, helping you plan your budget better.",
    // answerTwo:
    //   "EMI=P×r×(1+r)n(1+r)n−1EMI = \frac{P \times r \times (1 + r)^n}{(1 + r)^n - 1}   ",
    // answerThree: "Where: ",
  },
  {
    id: 2,
    question: "How Can I Lower My EMI?",

    answerList: [
      {
        info: "Opt for a longer loan tenure to reduce monthly payments.",
      },
      {
        info: "Transfer your loan to Kotak Mahindra Bank if they offer a lower interest rate.",
      },
      {
        info: "Make prepayments to reduce the loan principal and EMI.",
      },
    ],
  },
  {
    id: 3,
    question: "Can I Calculate EMI for Different Scenarios?",
    answer:
      "Yes, MinEMI’s EMI calculator allows you to adjust loan parameters like amount, tenure, and interest rate to simulate various scenarios.",
  },
  {
    id: 4,
    question: "How Does the Interest Rate Impact My EMI?",
    answer:
      "The EMI increases or decreases based on the interest rate. For example, a 0.5% reduction in the rate can save thousands in monthly payments over the tenure.",
  },
  {
    id: 5,
    question: "What Are the Key Factors Affecting EMI?",
    answerList: [
      {
        head: "Loan Amount: ",
        info: "Higher amounts lead to higher EMIs.",
      },
      {
        head: "Interest Rate: ",
        info: "A lower rate reduces your monthly payments.",
      },
      {
        head: "Loan Tenure: ",
        info: "Longer tenures lower EMIs but increase total interest.",
      },
    ],
  },
  {
    id: 6,
    question: "Are There Any Penalties for Prepayments?",
    answer:
      "Kotak Mahindra Bank may charge a penalty for prepaying a home loan. Check your loan agreement or consult with the bank before making prepayments.",
  },
  {
    id: 7,
    question: "Can I Use the EMI Calculator for a Balance Transfer?",
    answer:
      "Yes, you can use the EMI calculator to compare your existing loan with a new balance transfer loan to see potential savings.",
  },
];
